import axios from "axios";
import { API_URL } from "./const";

interface ContactFormData {
  companyName: string;
  fullName: string;
  email: string;
  phone: string;
  message: string;
}

class ContactService {
  submitContactForm(formData: ContactFormData) {
    return axios.post(API_URL + "contact", formData);
  }
}

export default new ContactService(); 